import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, switchMap, map, catchError, of } from 'rxjs';
import * as fromSubscriptionsActions from '../actions/subscriptions.actions';
import { SubscriptionFirebaseResponse } from 'src/app/models/subscription.model';
import {
  AngularFirestore,
  QueryFn,
  Query
} from '@angular/fire/compat/firestore';
import { FirebaseService } from 'src/app/services/firebase/firebase.service';

@Injectable()
export class SubscriptionsEffects {
  private readonly collectionName = 'subscriptions';
  constructor(
    private readonly action$: Actions,
    private readonly firebaseService: FirebaseService,
    private readonly firestore: AngularFirestore
  ) {}

  // Load Subscription
  loadSuscriptions$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(fromSubscriptionsActions.LoadSubscriptionsAction),
      map(({ trainerId }) => {
        const queryFn: QueryFn = (ref) => {
          let query: Query = ref;
          const trainerRef = this.firestore.doc(`users/${trainerId}`).ref;
          query = query.where('trainerRef', '==', trainerRef);
          query = query.orderBy('date', 'desc');
          return query;
        };

        return this.firebaseService
          .getDataOfCollectionByMultipleFields(this.collectionName, queryFn)
          .pipe(
            map((resp) =>
              resp.docs
                .map((doc) => ({
                  ...(doc.data() as SubscriptionFirebaseResponse),
                  id: doc.id
                }))
                .map((doc) => {
                  delete doc.trainerRef;
                  return {
                    ...doc,
                    date: new Date(doc.date.seconds * 1000),
                    payDate: doc.payDate
                      ? new Date(doc.payDate.seconds * 1000)
                      : null
                  };
                })
            )
          );
      }),
      switchMap((resp) => resp),
      map((subscriptionsEvents) => ({
        type: fromSubscriptionsActions.LOAD_SUBSCRIPTIONS_SUCCESS,
        data: subscriptionsEvents
      })),
      catchError((error) =>
        of({ type: fromSubscriptionsActions.LOAD_SUBSCRIPTIONS_FAIL, error })
      )
    )
  );
}
